import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text
} from "@chakra-ui/react";

export const ConfirmConvertStatementModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
}) => (
  <Modal size="xl" isOpen={isOpen} onClose={onClose} isCentered>
    <ModalOverlay />
    <ModalContent p={4} borderRadius={20}>
      <ModalHeader fontSize={20} color="secondary.600" fontWeight={600} pb={0}>
        Confirm Transactions
      </ModalHeader>
      <ModalCloseButton top={7} right={8} />
      <ModalBody pb={6} pt={2}>
        <Text fontSize={14} fontWeight={500} mb={6}>
          You confirm that all transactions have been reviewed or edited and
          match the uploaded bank statement. Click continue to send all the
          transactions to Jack.
        </Text>
        <HStack justify="flex-end" spacing={4}>
          <Button
            w={93}
            onClick={onClose}
            variant="outline"
            size="sm"
            h={9}
            fontWeight={500}
          >
            Cancel
          </Button>
          <Button
            w={157}
            onClick={onConfirm}
            colorScheme="primary"
            size="sm"
            h={9}
            fontWeight={500}
            isLoading={isLoading}
          >
            Continue
          </Button>
        </HStack>
      </ModalBody>
    </ModalContent>
  </Modal>
);
